import type { ReactNode } from "react";
import classnames from "classnames";

import style from "./style.module.scss";

interface PageContentProps {
  title?: ReactNode;
  description?: ReactNode;
  actions?: ReactNode;
  maxWidth?: number;
  children?: ReactNode;
  className?: string;
}

function PageContent({
  title,
  description,
  actions,
  maxWidth = 800,
  children,
  className,
}: PageContentProps) {
  return (
    <div className={classnames(style.pageContent, className)}>
      <div className={style.inner} style={{ maxWidth }}>
        <div className={style.header}>
          <div className={style.headerText}>
            <h1 className={style.title}>{title}</h1>
            <p className={style.description}>{description}</p>
          </div>
          {actions && <div className={style.actions}>{actions}</div>}
        </div>
        {children}
      </div>
    </div>
  );
}

export default PageContent;
